export default {
  state: {
    // 地图显示中心点
    mapCenter: null,
    // 更新数采器列表
    updateDataloggerList: false,
    // 更新设备列表
    updateDeviceList: false,
    // 更新项目列表
    updateProjectList: false,
    // 更新关注态
    updateFocus: false,
    // 更新账号列表
    updateAccountList: false,
    // 账号管理左侧创建用户更新右侧用户列表
    updateUsrSList: false,
    // 业主更新左侧SidebarNew
    foldGeneralSidebarNew: false,
    // 更新树形控件
    sidebarmodeTree: false,
    // 判断用户数据是否加载完成，防止用户接口过慢切换过快数据错乱
    sidebartabUsrGroup: false,
  },
  mutations: {
  },
  actions: {
  }
}